import getLocalWishlist from '../utils/getLocalWishlist';
import fetchRemoteWishlist from '../utils/requests/fetchRemoteWishlist';
import getProductGidByHandle from '../utils/requests/getProductGidFromHandle';
import updateRemoteWishlist from '../utils/requests/updateRemoteWishlist';
import CONSTANTS from '../utils/vars/CONSTANTS';

class WishlistManager {
  constructor() {
    console.log('[Wishlist Manager] initialized');

    this.syncWishlists();
  }

  get localWishlist() {
    return getLocalWishlist();
  }

  async syncWishlists() {
    if (!CONSTANTS.CUSTOMER_LOGGED_IN) return;

    const remoteWishlist = (await fetchRemoteWishlist()) || [];
    const combinedWishlist = [...new Set([...this.localWishlist, ...remoteWishlist])];
    if (combinedWishlist.length === 0) return;

    this.updateLocalStorage(combinedWishlist);
    await this.syncRemoteWishlist(remoteWishlist);
  }

  updateLocalStorage(wishlist) {
    const wishlistString = wishlist.join(CONSTANTS.LOCAL_STORAGE_DELIMITER);
    localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlistString);
  }

  async syncRemoteWishlist(remoteWishlist) {
    const newWishlistItems = this.localWishlist.filter((productHandle) => !remoteWishlist.includes(productHandle));
    if (newWishlistItems.length === 0) return;

    for (const productHandle of newWishlistItems) {
      const productGid = await getProductGidByHandle(productHandle);
      if (productGid) await updateRemoteWishlist(productGid);
    }
  }
}

new WishlistManager();
